import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
    name: 'filterClientManagement',
    standalone: false
})
  export class filterClientManagement implements PipeTransform {
    transform(items:(any[] | null), ClientEmail: string, ClientFirstname:string, ClientLastname:string, TypeIdentification:string, NumberIdentification:string): any[] {
        if (!items) {
            return [];
          }
          if (!ClientEmail && !ClientFirstname && !ClientLastname && !TypeIdentification && !NumberIdentification) {
            return items;
          }

          //  change de words a lower case example ASD = asd
          const normalize = (value: unknown): string => String(value ?? '').trim().toLocaleLowerCase();
          ClientEmail = normalize(ClientEmail);
          ClientFirstname = normalize(ClientFirstname);
          ClientLastname = normalize(ClientLastname);
          TypeIdentification = normalize(TypeIdentification);
          NumberIdentification = normalize(NumberIdentification);

          return items.filter(item => {
            const ClientEmailMatch = normalize(item?.Email).includes(ClientEmail);
            const ClientFirstNameMatch = normalize(item?.FirstName).includes(ClientFirstname);
            const ClientLastNameMatch = normalize(item?.LastName).includes(ClientLastname);
            const TypeIdentificationMatch = normalize(item?.TypeName).includes(TypeIdentification);
            const NumberIdentificationMatch = normalize(item?.Identification).includes(NumberIdentification);
            return ClientEmailMatch && ClientFirstNameMatch && ClientLastNameMatch && TypeIdentificationMatch && NumberIdentificationMatch;
          });

    }
  }
